import AddQuestionnaireBottomContainer from "./AddQuestionnaireBottomContainer";

export default AddQuestionnaireBottomContainer;
